module.exports = __webpack_public_path__ + "static/media/noImageDefault.88daab05.svg";